<ng-template #content>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" i18n="add-stats-modal|@@choose_component_to_add">Choisissez un bloc à ajouter</h4>
    <button type="button" class="close" aria-label="Close" (click)="modalRef.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    MODAL BODY
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modalRef.close('Save click')">Save</button>
  </div>
</ng-template>

<button class="btn btn-lg add-block" (click)="open(content)"><span i18n="add-stats-modal|@@add_component">Vous souhaitez rajouter un autre bloc?</span><span><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
      <title>Plus</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="UI-Rapport" transform="translate(-1165.000000, -305.000000)" fill="#ffffff" fill-rule="nonzero">
          <g id="Content" transform="translate(165.000000, 269.000000)">
            <g id="01" transform="translate(14.000000, 24.000000)">
              <g id="Group-18" transform="translate(784.000000, 9.000000)">
                <path d="M210,3 C205.6,3 202,6.6 202,11 C202,15.4 205.6,19 210,19 C214.4,19 218,15.4 218,11 C218,6.6 214.4,3 210,3 Z M214,12 L211,12 L211,15 L209,15 L209,12 L206,12 L206,10 L209,10 L209,7 L211,7 L211,10 L214,10 L214,12 Z" id="Shape"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg></span></button>


// WEBPACK FOOTER //
// ./src/app/add-stats-modal/add-stats-modal.component.html